<template>
    <div>
        <!-- <div class="">

        </div> -->
        <div class="container">

            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a href="/" @click="getSoundClick();">
                            <i class="lisa-icon-back"></i>
                        </a>
                    </li>
                    <li>
                        <a href="/" style="font-weight:700">{{ $t('profile') }}</a>
                    </li>
                </ul>
            </div>

            <template v-if="user_info.student_type != 2">
                <div id="card-profile" class="card">
                    <input type="checkbox" id="card-basic-info" class="card-input" checked />

                    <label class="card-header-label" for="card-basic-info">
                        <div class="card-title">{{ $t('basic_info') }}</div>
                        <div class="card-tools hide" v-show="user_info.student_type != 2">
                            <!-- <button class="btn btn-card-header" @click="onSubmit">{{ $t('save') }}</button> -->
                            <!-- <button :class="showBtnSubmit ? 'btn btn-card-header' : 'btn btn-card-header hide'" @click="onSubmit">{{ $t('save') }}</button> -->
                            <button class="btn btn-card-header" @click="onSubmit" v-if="isShowSaveButton(user)">{{ $t('save') }}</button>
                        </div>
                    </label>

                    <div class="card-body hide">
                        <div class="profile-basic-content">
                            <div class="profile-basic-avatar">
                                <div class="profile-basic-avatar-info">
                                    <div class="thumb">
                                        <div class="thumb-content">
                                            <img class="avatar" :src="user_info.avatar_url" alt="" v-if="user_info.avatar_url" />
                                            <img class="avatar" src="/themes/web/assets/images/avatar-default.svg" alt="" v-else />
                                        </div>
                                    </div>

                                    <a href="#" class="upload" data-bs-toggle="modal" data-bs-target="#profileUploadModal" v-show="user_info.student_type != 2">
                                        <i class="lisa-icon-profile-upload"></i>
                                    </a>
                                    <img class="emotion" :src="user_info.emoji_url" alt="" v-show="user_info.emoji_url && user_info.student_type != 2" />
                                </div>

                                <div class="row mb-15" v-show="user_info.student_type != 2">
                                    <div class="col-md-6 text-right">
                                        <span class="key">{{ $t('username') }}:</span>
                                    </div>
                                    <div class="col-md-6 text-left">
                                        <span class="val">{{ user_info.username }}</span>
                                    </div>
                                </div>
                                <div class="row mb-15" v-show="user_info.student_type != 2">
                                    <div class="col-md-6 text-right">
                                        <span class="key">{{ $t('key_account') }}:</span>
                                    </div>
                                    <div class="col-md-6 text-left">
                                        <span class="val">{{ user_info.key_child }}</span>
                                    </div>
                                </div>
                                <div class="profile-basic-avatar-btn" v-show="user_info.student_type != 2">
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#changePasswordModal">
                                        <button class="btn btn-change-password">
                                            <i class="lisa-icon-profile-lock"></i> {{ $t('change_password') }}
                                        </button>
                                    </a>
                                </div>
                                <div class="profile-basic-avatar-btn" v-show="user_info.student_type != 2">
                                    <!-- <div>
                                        <button class="btn btn-upgrade-account">
                                            <i class="lisa-icon-profile-upgrade"></i> {{$t('upgrade_account') }}
                                        </button>
                                    </div> -->
                                    <router-link :to="{ name: 'upgrade_account' }">
                                        <button class="btn btn-upgrade-account">
                                            <i class="lisa-icon-profile-upgrade"></i> {{ $t('upgrade_account') }}
                                        </button>
                                    </router-link>
                                </div>
                            </div>
                            <div class="profile-basic-info">

                                <form action="#">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="profile-fullname" class="form-label">{{ $t('full_name') }}</label>
                                            <input :disabled="user_info.student_type == 1" type="text" class="form-control" id="profile-fullname" name="full_name" :placeholder="$t('full_name')" v-model="user.fullname" autocomplete="off" />
                                        </div>
                                    </div>
                                    <div class="row" v-show="user_info.student_type != 2">
                                        <div class="col-md-6">
                                            <label for="profile-birthday" class="form-label">{{ $t('birthday') }}</label>
                                            <div class="form-control-calander">
                                                <input type="text" class="form-control datepicker" id="profile-birthday" name="birthday" :placeholder="$t('birthday')" v-model="user.birthday" autocomplete="off" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <label for="profile-gender" class="form-label">{{ $t('gender') }}</label>
                                            <div class="select-wrapper">
                                                <select name="province" id="profile-gender" class="form-control" v-model="user.gender">
                                                    <option value="male" selected>{{ $t('male') }}</option>
                                                    <option value="female">{{ $t('female') }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6" id="profile-grade-checked">
                                            <label for="profile-grade" class="form-label">{{ $t('grade') }}</label>
                                            <div :class="user_info.placement_test != 0 ? 'form-control-checked' : 'form-control-checked disabled'">
                                                <input :disabled="user_info.student_type == 1" type="text" class="form-control" id="profile-grade" v-model="user.grade_active" :placeholder="$t('grade')" autocomplete="off" />
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="user_info.student_type != 0">
                                            <label for="profile-class" class="form-label">{{ $t('class') }}</label>
                                            <div>
                                                <input :disabled="user_info.student_type == 1" type="text" class="form-control" id="profile-class" v-model="user.contact_school.class" autocomplete="off" />
                                            </div>
                                        </div>
                                        <div v-else>

                                        </div>
                                        <div class="col-sm-6">
                                            <div class="col-form-label test_button" v-if="user_info.placement_test == 0" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#placementModal">{{ $t('placement_test') }}</div>
                                        </div>
                                        <!--<div class="col-md-6">
                                            <label for="profile-class" class="form-label">{{ $t('class') }}</label>
                                            <input type="text" class="form-control" id="profile-class" :placeholder="$t('class')" v-model="user.class" autocomplete="off" />
                                        </div>-->
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label class="col-form-label">{{ $t('phone') }}</label>
                                            <div class="position-relative d-flex gap-3">
                                                <input type="text" name="grade" class="form-control custom-input  mb-0" :class="user_info.phone_verified ? 'is-valid' : 'is-warning'" :value="user_info.contact_user.phone" disabled autocomplete="off">
                                                <router-link :to="{ name: 'account_verify', params: { tab: 'phone' } }" class="lisa-btn-small ito-btn-warning" @click.native="getSoundClick" v-if="!user_info.phone_verified">
                                                    {{ $t('btn_verify') }}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label class="col-form-label">{{ $t('email') }}</label>
                                            <div class="position-relative d-flex gap-3">
                                                <input type="text" name="grade" class="form-control custom-input mb-0" :class="user_info.email_verified ? 'is-valid' : 'is-warning'" :value="user_info.email" disabled autocomplete="off">
                                                <router-link :to="{ name: 'account_verify', params: { tab: 'email' } }" class="lisa-btn-small ito-btn-warning" @click.native="getSoundClick" v-if="!user_info.email_verified">
                                                    {{ $t('btn_verify') }}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-show="user_info.student_type != 2">
                                        <div class="col-md-12" style="margin-top:20px">
                                            <!-- <span>{{$t('account_type')}}:</span> <span class="profile-hightline mr-30">{{getAccountTypeText(user.account_type)}}</span>  -->
                                            <span>{{ $t('account_type') }}:</span> <span class="profile-hightline mr-30">{{ user.name_package }}</span>
                                            <span>{{ $t('exp_date') }}:</span> <span class="profile-hightline">{{ user.expired_date }}</span>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <input type="checkbox" id="card-contact-detail" class="card-input" />

                    <label class="card-header-label" for="card-contact-detail">
                        <div class="card-title">{{ $t('contact_details') }}</div>
                        <div class="card-tools hide">
                            <!-- <button :class="showBtnContact ? 'btn btn-card-header' : 'btn btn-card-header hide'" @click="updateContact">{{ $t('save') }}</button> -->
                            <button class="btn btn-card-header" @click="updateContact" v-if="isShowContactSaveButton(user)">{{ $t('save') }}</button>
                        </div>
                    </label>

                    <div class="card-body hide pb-35">
                        <form action="#">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="profile-phone" class="form-label">{{ $t('phone') }}</label>
                                    <input :disabled="user_info.student_type == 1" type="number" class="form-control" id="profile-phone" :placeholder="$t('phone')" v-model="user.contact_user.phone" autocomplete="off" />
                                </div>
                                <div class="col-md-6">
                                    <label for="profile-email" class="form-label">{{ $t('email') }}</label>
                                    <input :disabled="user_info.student_type == 1" type="email" class="form-control" id="profile-email" :placeholder="$t('email')" v-model="user.email" autocomplete="off" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="profile-country" class="form-label">{{ $t('country') }}</label>
                                    <div class="select-wrapper">
                                        <select :disabled="user_info.student_type == 1" name="profile_country" id="profile-country" class="form-control" @change="addEvent" v-model="user.contact_user.country_id">
                                            <option :value="country.id" v-for="(country, index) in countries" v-bind:key="index">{{ country.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="profile-province" class="form-label">{{ $t('province') }}</label>
                                    <div class="select-wrapper">
                                        <select :disabled="user_info.student_type == 1" name="profile_province" id="profile-province" class="form-control" @change="addEvent" v-model="user.contact_user.city_id">
                                            <option :value="province.id" v-for="(province, index) in provinces" v-bind:key="index">{{ province.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="profile-address-1" class="form-label">{{ $t('ward') }}</label>
                                    <div class="select-wrapper">
                                        <select :disabled="user_info.student_type == 1" name="profile_ward" id="profile-ward" class="form-control" @change="addEvent" v-model="user.contact_user.ward_id">
                                            <option :value="ward.id" v-for="(ward, index) in wards" v-bind:key="index">{{ ward.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="profile-address-2" class="form-label">{{ $t('address') }}</label>
                                    <input :disabled="user_info.student_type == 1" type="text" class="form-control" id="profile-address" :placeholder="$t('address')" v-model="user.contact_user.address" autocomplete="off" />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="card" v-if="user.account_type != 1 && user.student_type == 1">
                    <input type="checkbox" id="card-school-info" class="card-input" />

                    <label class="card-header-label" for="card-school-info">
                        <div class="card-title">{{ $t('school_informations') }}</div>
                        <div class="card-tools hide">
                            <!--<button class="btn btn-card-header" @click="updateSchoolInfo">{{ $t('save') }}</button>-->
                        </div>
                    </label>

                    <div class="card-body hide">
                        <div class="row">
                            <div class="col-md-6">
                                <label for="profile-school" class="form-label">{{ $t('school') }}</label>
                                <div class="select-wrapper">
                                    <input type="text" class="form-control" id="profile-school-school" :placeholder="$t('school')" v-model="user.contact_school.school" disabled autocomplete="off" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="profile-class" class="form-label">{{ $t('class') }}</label>
                                <div class="select-wrapper">
                                    <input type="text" class="form-control" id="profile-school-class" :placeholder="$t('class')" v-model="user.contact_school.class" disabled autocomplete="off" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label for="profile-country" class="form-label">{{ $t('country') }}</label>
                                <div class="select-wrapper">
                                    <input type="text" class="form-control" id="profile-school-country" :placeholder="$t('country')" v-model="user.contact_school.country" disabled autocomplete="off" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="profile-province" class="form-label">{{ $t('province') }}</label>
                                <div class="select-wrapper">
                                    <input type="text" class="form-control" id="profile-school-province" :placeholder="$t('province')" v-model="user.contact_school.city" disabled autocomplete="off" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label for="profile-address-1" class="form-label">{{ $t('ward') }}</label>
                                <div class="select-wrapper">
                                    <input type="text" class="form-control" id="profile-school-ward" :placeholder="$t('ward')" v-model="user.contact_school.ward" disabled autocomplete="off" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="profile-address-2" class="form-label">{{ $t('address') }}</label>
                                <input type="text" class="form-control" id="profile-school-address" :placeholder="$t('address')" v-model="user.contact_school.address" disabled autocomplete="off" />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div id="profile-free-trail" class="card">
                    <label class="card-header">
                        <div class="card-title">{{ $t('basic_info') }}</div>
                        <div class="block-btn d-flex">
                            <a href="/register?type=student"><button class="lisa-btn-fit active">{{ $t('save') }}</button></a>
                            <button class="lisa-btn-fit logout d-flex align-items-center" @click="onLogout">
                                <span style="margin-right:8px">{{ $t('log_out') }}</span>
                                <img src="/themes/ito/images/icon-logout.svg" alt="">
                            </button>
                        </div>
                    </label>
                    <div class="card-body">
                        <div class="profile-free-trail">

                            <div class="profile-basic-avatar">
                                <div class="profile-basic-avatar-info">
                                    <div class="thumb">
                                        <div class="thumb-content">
                                            <img class="avatar" :src="user_info.avatar_url" alt="" v-if="user_info.avatar_url" />
                                            <img class="avatar" src="/themes/web/assets/images/avatar-default.svg" alt="" v-else />
                                        </div>
                                    </div>

                                    <a href="#" class="upload" data-bs-toggle="modal" data-bs-target="#profileUploadModal">
                                        <i class="lisa-icon-profile-upload"></i>
                                    </a>
                                </div>
                                <div class="block-info">
                                    <span class="label">UserID:</span>
                                    <span class="userid">{{ user_info.user_id }}</span>
                                </div>
                            </div>

                            <div class="profile-free-trail-right">
                                <div class="profile-basic-info">
                                    <form action="#">
                                        <div class="row">
                                            <div class="">
                                                <label for="profile-fullname" class="form-label" style="width: 84px;">{{ $t('full_name') }}</label>
                                                <input type="text" class="form-control" id="profile-fullname" name="full_name" :placeholder="$t('full_name')" v-model="user.fullname" disabled autocomplete="off" />
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="">
                                                <label for="profile-grade" class="form-label" style="width: 84px;">{{ $t('grade') }}</label>
                                                <div class="d-flex">
                                                    <div class="form-control-checked disabled flex">
                                                        <input type="text" class="form-control" id="profile-grade" v-model="user.grade" :placeholder="$t('grade')" autocomplete="off" style="margin-bottom: 0;" />
                                                    </div>
                                                    <div class="">
                                                        <a href="#" class="placement-test-link" @click="doTest">{{ $t('placement_test') }}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--<div class="row" style="margin-top: 15px;">
                                            <div class="col-md-6 d-flex">
                                                <label for="profile-grade" class="form-label" style="width: 84px;"></label>
                                                <div>
                                                    <button class="btn btn-card-header" style="padding: 10px 20px; font-size: 14px;">
                                                        <i class="lisa-icon-user-yellow"></i> {{$t('save_your_progress')}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>-->
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <div class="modal fade modal-flex" id="cropAvatarModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="cropAvatarModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 475px; max-width: 475px;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">Edit image</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="avatar-edit-form">
                                <img id="image-crop" :src="avatar_crop_data" alt="">
                            </div>
                        </div>
                        <div class="modal-footer" style="justify-content: center;">
                            <button type="button" id="image-choose-img" class="btn btn-choose-image choose-image-other" @click="chooseImage" style="padding: 10px 30px;"> {{ $t('choose_image') }}</button>
                            <button type="button" id="image-crop-save" class="btn btn-main-sm" style="padding: 10px 30px;" @click="cropSave">{{ $t('save') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="profileUploadModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="profileUploadModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 576px; max-width: 576px;">
                    <div class="modal-content">
                        <div class="modal-body pd0">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="profile-modal-content">
                                <div class="profile-modal-content-left">
                                    <h4 class="title">Student profile</h4>
                                    <div class="profile-basic-avatar">
                                        <div class="profile-basic-avatar-info">
                                            <div class="thumb">
                                                <div class="thumb-content">
                                                    <img class="avatar" ref="avatar_url" :src="user_info.avatar_url ? user_info.avatar_url : '/themes/web/assets/images/avatar-default.svg'" alt="" />
                                                </div>
                                            </div>

                                            <!-- <a href="#"  data-bs-toggle="modal" data-bs-target="#profileUploadModal">
                                                <i class="lisa-icon-profile-upload"></i>
                                            </a> -->

                                            <!-- <a href="#" class="upload">
                                                <i class="lisa-icon-profile-upload"></i>
                                            </a> -->

                                            <img ref="emoticon_url" :class="!user.emoji_url ? 'emotion hide' : 'emotion'" :src="user_info.emoji_url" alt="" />
                                        </div>
                                    </div>

                                    <div>
                                        <button class="btn btn-main btn-save" :disabled="disable_button_update_avatar" @click="updateAvatar">{{ $t('save') }}</button>
                                    </div>
                                </div>
                                <div class="profile-modal-content-right">

                                    <nav>
                                        <div class="nav nav-tabs" role="tablist">
                                            <button class="nav-link active" id="nav-avatar-tab" data-bs-toggle="tab" data-bs-target="#nav-avatar" type="button" role="tab" aria-controls="nav-home" aria-selected="true">{{ $t('avatar') }}</button>
                                            <button class="nav-link" id="nav-emoticon-tab" data-bs-toggle="tab" data-bs-target="#nav-emoticon" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">{{ $t('sticker') }}</button>
                                        </div>
                                    </nav>
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="nav-avatar" role="tabpanel" aria-labelledby="nav-avatar-tab">
                                            <div class="avatars nano">
                                                <div class="nano-content">
                                                    <div class="avatar-items list-avatars">
                                                        <div class="row">
                                                            <!-- <div class="col-md-3">
                                                                <div class="avatar-item-upload">
                                                                    <label for="avatar-item-upload">
                                                                        <i class="lisa-icon-profile-upload-1"></i>
                                                                        Upload
                                                                    </label>

                                                                    <input type="file" id="avatar-item-upload" name="avatar" accept="image/*" @change="addEvent"/>
                                                                </div>
                                                            </div> -->

                                                            <div class="col-md-3" v-for="(avatar, index) in avatars" @click="selectAvatar(avatar)" v-bind:key="index">
                                                                <div :class="avatar.id == user.avatar_id ? 'avatar-item active' : 'avatar-item'">
                                                                    <div class="thumb">
                                                                        <div class="thumb-content">
                                                                            <img class="thumb-img br8" :src="avatar.url" alt="" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="gem-info" v-if="avatar.price > 0">
                                                                        {{ avatar.price }} <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="nav-emoticon" role="tabpanel" aria-labelledby="nav-emoticon-tab">
                                            <div class="avatars nano">
                                                <div class="nano-content">
                                                    <div class="avatar-items list-emoticons">
                                                        <div class="row">
                                                            <div class="col-md-3" v-for="(emoticon, index) in emoticons" @click="selectEmoticon(emoticon)" v-bind:key="index">
                                                                <div :class="emoticon.id == user.emoji_id ? 'avatar-item active' : 'avatar-item'">
                                                                    <div class="thumb">
                                                                        <div class="thumb-content">
                                                                            <img class="thumb-img-emoticon" :src="emoticon.url" alt="" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="gem-info" v-if="avatar.price > 0">
                                                                        {{ avatar.price }} <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal modal-flex" id="changePasswordModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="changePasswordModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 500px; max-width: 500px;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $t('change_password') }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                        </div>
                        <div class="modal-body">
                            <div class="change-password-form">
                                <div class="mb-12">{{ $t('password_description') }}</div>

                                <div class="form-control-password">
                                    <input :type="showPass ? 'text' : 'password'" :class="errors.current_password ? 'form-control has-error' : 'form-control'" name="current_password" :placeholder="$t('placeholder_current_password')"
                                        v-model="current_password">
                                    <i :class="[showPass ? 'lisa-icon-eye-1' : 'lisa-icon-eye-2']" @click="showPass = !showPass"></i>
                                </div>
                                <div class="password-strength" v-if="new_password != '' && strength_1 == 0">
                                    <div :class="strength > 0 ? 'password-strength-item red' : 'password-strength-item'"></div>
                                    <div :class="strength > 1 ? 'password-strength-item red' : 'password-strength-item'"></div>
                                    <div :class="strength > 2 ? 'password-strength-item red' : 'password-strength-item'"></div>
                                </div>
                                <div class="password-strength" v-if="new_password != '' && strength_1 == 1">
                                    <div :class="strength > 0 ? 'password-strength-item yellow' : 'password-strength-item'"></div>
                                    <div :class="strength > 1 ? 'password-strength-item yellow' : 'password-strength-item'"></div>
                                    <div :class="strength > 2 ? 'password-strength-item yellow' : 'password-strength-item'"></div>
                                </div>
                                <div class="password-strength" v-if="new_password != '' && strength_1 == 2">
                                    <div :class="strength > 0 ? 'password-strength-item green' : 'password-strength-item'"></div>
                                    <div :class="strength > 1 ? 'password-strength-item green' : 'password-strength-item'"></div>
                                    <div :class="strength > 2 ? 'password-strength-item green' : 'password-strength-item'"></div>
                                </div>
                                <div class="password-strength-txt" v-if="new_password != '' && strength_1 == 0">{{ $t(`${textStrength}`) }}</div>
                                <div class="password-strength-txt yellow" v-if="new_password != '' && strength_1 == 1">{{ $t(`${textStrength}`) }}</div>
                                <div class="password-strength-txt green" v-if="new_password != '' && strength_1 == 2">{{ $t(`${textStrength}`) }}</div>

                                <div class="form-control-password">
                                    <input :type="showNewPass ? 'text' : 'password'" class="form-control" name="new_password" :placeholder="$t('placeholder_new_password')" v-model="new_password">
                                    <i :class="[showNewPass ? 'lisa-icon-eye-1' : 'lisa-icon-eye-2']" @click="showNewPass = !showNewPass"></i>
                                </div>
                                <div class="form-control-password">
                                    <input :type="showConfirmPass ? 'text' : 'password'" :class="errors.confirm_password ? 'form-control has-error' : 'form-control'" name="confirm_password" :placeholder="$t('placeholder_confirm_password')"
                                        v-model="confirm_password">
                                    <i :class="[showConfirmPass ? 'lisa-icon-eye-1' : 'lisa-icon-eye-2']" @click="showConfirmPass = !showConfirmPass"></i>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" :class="current_password != '' && new_password != '' && confirm_password != '' ? 'lisa-btn-small active' : 'lisa-btn-small'"
                                :disabled="current_password == '' || new_password == '' || confirm_password == ''" @click="changeNewPass()">
                                {{ $t('save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="formErrorModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 360px; max-width: 360px;margin-top: 145px;">
                    <div class="modal-content" style="padding: 12px 20px 24px;">
                        <div class="modal-header">
                            <h5 class="modal-title text-red">{{ $t('has_error') }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div>{{ $t(`${error_message}`) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="formErrorModal_1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal_1" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $t(`${error_message}`) }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div>{{ $t(`${error_sub_message}`) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="formSuccessModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 365px; max-width: 365px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">Password updated</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/modal-image-success.svg" alt="" />

                                <div class="welcome-back-content">
                                    Password has been updated successfully.
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-main-border m-auto" data-bs-dismiss="modal" aria-label="Close" style="padding: 8px 20px;">Next</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="profileUpdated" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Success</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/modal-image-success.svg" alt="" />

                                <div class="welcome-back-content">
                                    Your profile has been update successfully.
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-main-border m-auto" data-bs-dismiss="modal" aria-label="Close">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="uploadErrorModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 450px; max-width: 450px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">Có lỗi xảy ra</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/icon-error.svg" alt="" />

                                <div class="welcome-back-content">
                                    Kích thước ảnh tối đa cho phép tải lên là 10Mb. Vui lòng chọn ảnh khác.
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" id="choose-image-other" class="btn btn-main-border m-auto" style="padding: 8px 20px;">Choose image</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { getAvatars, updateAvatar, updateProfile, updateContact } from '../../models/profile'
import { getCountries, getProvinces, getWards } from '../../models/config'
import { changeNewPassword } from '../../models/auth'
import AppIcon from "@/components/common/AppIcon.vue";
import axios from "axios";
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
import moment from 'moment'

export default {
    name: "Profile",
    title: 'Profile',
    components: {
        AppIcon
    },

    data() {
        return {
            errors: {
                address: '',
                fullname: '',
                current_password: '',
                new_password: '',
                confirm_password: '',
            },
            user: {
                grade_active: '',
                name_package: '',
                fullname: '',
                birthday: '',
                email: '',
                gender: 'male',
                grade: 0,
                type: 2,
                avatar_id: -1,
                avatar_img: '',
                emoji_id: 0,
                extension_file: 'png',
                student_type: 0,
                account_type: 0,
                user_name: '',
                expired_date: '',
                key_child: '',
                contact_user: {
                    country_id: 1,
                    city_id: 0,
                    ward_id: 0,
                },
                contact_school: {}
            },
            countries: [],
            provinces: [],
            wards: [],
            showPass: false,
            showNewPass: false,
            showConfirmPass: false,
            avatar: '',
            avatars: [],
            emoticons: [],
            current_password: '',
            new_password: '',
            confirm_password: '',
            strength: 0,
            classStrength: '',
            textStrength: 'password_strength_weak',
            avatar_crop_data: '',
            disable_button_update_avatar: true,
            cropper: null,
            error_message: '',
            error_sub_message: '',
            key_change_contact: '',
            key_change_info: '',
            is_valid: true,
            showBtnSubmit: false,
            strength_1: 0,
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info
        }
    },

    mounted() {
        let self = this
        $("#profile-birthday").datepicker({
            dateFormat: 'dd/mm/yy',
            changeMonth: true,
            changeYear: true,
            showOtherMonths: true,
            selectOtherMonths: false,
            yearRange: '1900:+0',
            maxDate: new Date(),
            onSelect: function (dateText) {
                self.user.birthday = dateText;
            }
        });
    },

    created() {
        this.fetch();
    },
    watch: {
        'new_password': function (newVal, oldVal) {
            if (newVal == this.current_password) {
                this.errors.new_password = "New password cannot be  the same as the current password.";
            } else if (newVal == this.user.user_name) {
                this.errors.new_password = "New password cannot be  the same as the username.";
            } else {
                this.errors.new_password = "";
            }
            this.strengPassword(newVal);
        },
        'strength': function (newVal, oldVal) {
            if (newVal == 1) {
                this.classStrength = 'pw-weak';
                this.textStrength = 'password_strength_weak';
            } else if (newVal == 2) {
                this.classStrength = 'pw-normal';
                this.textStrength = 'password_strength_good';
            } else if (newVal == 3) {
                this.classStrength = 'pw-strong';
                this.textStrength = 'password_description_strong';
            } else {
                this.classStrength = '';
                this.textStrength = '';
            }
        },
        'confirm_password': function (newVal, oldVal) {
            this.errors.confirm_password = (newVal != this.new_password) ? 'Confirm password does not match.' : '';
        }
    },
    methods: {
        async fetch() {
            const that = this;

            await axios.all([
                getAvatars(),
                getCountries(),
                getProvinces({
                    country_id: that.user_info.contact_user.country_id ? that.user_info.contact_user.country_id : 1
                }),
                getWards({
                    province_id: that.user_info.contact_user.city_id
                }),
            ]).then(axios.spread((response, response_countries, response_provinces, response_wards) => {
                if (response.data.code != 0) {
                    return;
                }

                const items = response.data.results.items || [];

                items.forEach(function (item) {
                    if (item.type == 0) {
                        that.avatars.push(item)
                    }
                    if (item.type == 1) {
                        that.emoticons.push(item)
                    }
                });

                that.countries = response_countries.data.results || [];
                that.provinces = response_provinces.data.results || [];
                that.wards = response_wards.data.results || [];
            }));

            const user = this.$store.state.user_info;

            console.log('User:', user);

            this.user.email = user.email;
            this.user.fullname = user.fullname;
            this.user.birthday = user.birthday;
            this.user.gender = user.gender;
            this.user.grade = user.grade;
            this.user.grade_active = user.grade_active
            this.user.avatar_id = user.avatar_id;
            this.user.emoji_id = user.emoji_id;
            this.user.emoji_url = user.emoji_url;
            this.user.avatar_img = user.avatar_url;
            this.user.student_type = user.student_type;
            this.user.user_name = user.username;
            this.user.account_type = user.account_type;
            this.user.name_package = user.name_package;
            this.user.key_child = user.key_child;
            this.user.email = user.email;
            this.user.phone = user.contact_user ? user.contact_user.phone : '';
            this.user.address = user.contact_user ? user.contact_user.address : '';
            this.user.contact_user = user.contact_user ? user.contact_user : null;
            this.user.contact_school = user.contact_school ? user.contact_school : null;
            this.user.expired_date = moment(user.expired_date).format('DD/MM/YYYY');

            if (this.user.contact_user) {
                if (!this.user.contact_user.city_id || this.user.contact_user.city_id == 0) {
                    this.user.contact_user.city_id = user.province.id;
                }
                if (!this.user.contact_user.ward_id || this.user.contact_user.ward_id == 0) {
                    this.user.contact_user.ward_id = user.ward.id;
                }
                if (!this.user.contact_user.city || this.user.contact_user.city == '') {
                    this.user.contact_user.city = user.province.name;
                }
                if (!this.user.contact_user.ward || this.user.contact_user.ward == '') {
                    this.user.contact_user.ward = user.ward.name;
                }
            }

            if (this.user.contact_school) {
                if (!this.user.contact_school.school || this.user.contact_school.school == '') {
                    this.user.contact_school.school = user.school;
                }
                if (!this.user.contact_school.class || this.user.contact_school.class == '') {
                    this.user.contact_school.class = user.class;
                }
                if (!this.user.contact_school.country || this.user.contact_school.country == '') {
                    this.user.contact_school.country = this.countries.find((country) => country.id === user.contact_user.country_id)?.name || '';
                }
                if (!this.user.contact_school.city || this.user.contact_school.city == '') {
                    this.user.contact_school.city = this.user.contact_user.city;
                }
                if (!this.user.contact_school.ward || this.user.contact_school.ward == '') {
                    this.user.contact_school.ward = this.user.contact_user.ward;
                }
            }

            this.key_change_contact = this.getKeyChangeContact(this.user);
            this.key_change_info = this.getKeyChangeInfo(this.user);

            this.$nextTick(function () {
                $('.datepicker').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showOtherMonths: true,
                    selectOtherMonths: false,
                    yearRange: '1900:+0',
                    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                });

                var initNanoScroller = function () {
                    if ($('.nano').length > 0) {
                        $(".nano").nanoScroller();
                    }
                }

                $('button[data-bs-toggle="tab"]').on('show.bs.tab', function (e) {
                    initNanoScroller();
                });
                $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
                    initNanoScroller();
                });
                $('#profileUploadModal').on('shown.bs.modal', function () {
                    initNanoScroller();
                });

                initNanoScroller();
            })
        },

        isShowSaveButton(user) {
            return this.key_change_info != this.getKeyChangeInfo(user);
        },

        isShowContactSaveButton(user) {
            return this.key_change_contact != this.getKeyChangeContact(user);
        },

        getKeyChangeContact(user) {
            return user.contact_user.phone +
                '|' + user.email +
                '|' + user.contact_user.country_id +
                '|' + user.contact_user.city_id +
                '|' + user.contact_user.ward_id +
                '|' + user.contact_user.address;
        },

        getKeyChangeInfo(user) {
            return user.fullname +
                '|' + user.birthday +
                '|' + user.gender;
        },

        getAccountTypeText(accountType) {
            switch (accountType) {
                case 1:
                    return 'FREE TRIAL';
                case 2:
                    return 'STANDARD';
                case 3:
                    return 'PLUS';
                case 4:
                    return 'PRO';
                default:
                    return "";
            }
        },
        showError(message) {
            this.error_message = message;

            $('.modal').modal('hide');

            $('#formErrorModal').modal('show');
        },

        showError_1(message, subMessage) {
            this.error_message = message;
            this.error_sub_message = subMessage;

            $('.modal').modal('hide');

            $('#formErrorModal_1').modal('show');
        },

        chooseImage() {
            if (this.cropper != null) {
                this.cropper.destroy();
            }

            $('#avatar-item-upload').click();
            $('.modal').modal('hide');
            // $('#profileUploadModal').modal('show');
        },

        cropSave() {
            const that = this;

            that.$store.commit("setLoading", true);

            const croppedImageDataURL = that.cropper.getCroppedCanvas().toDataURL("image/png");

            updateAvatar({
                avatar_id: -1,
                avatar_img: croppedImageDataURL,
                emoji_id: 0,
                type: 0,
                extension_file: 'png',
            }).then((response) => {
                that.$store.commit("setLoading", false);

                $('#cropAvatarModal').modal('hide');

                that.cropper.destroy();

                if (response.data.code != 0) {
                    that.showError(response.data.msg)

                    return;
                }

                const time = new Date().getTime();

                that.user_info.avatar_id = response.data.results.avatar_id;
                that.user_info.avatar_url = response.data.results.avatar_url + '?v=' + time;
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                $('#cropAvatarModal').modal('hide');

                that.cropper.destroy();

                //console.error(response)
            });
        },

        cropeChange({ coordinates, canvas }) {
            if (coordinates.height == 0) {
                return;
            }

            this.avatar_crop_data = canvas.toDataURL("image/png");
        },

        searchEvent({ target }) {
            this.user[target.name] = target.value;
        },

        addEvent({ target }) {
            const that = this;
            switch (target.name) {
                case 'profile_country':
                    getProvinces({
                        country_id: that.user_info.contact_user.country_id
                    }).then((response) => {
                        if (response.data.code != 0) {
                            return;
                        }
                        that.provinces = response.data.results || [];
                    });

                    break;
                case 'profile_province':
                    getWards({
                        province_id: that.user_info.contact_user.city_id
                    }).then((response) => {
                        if (response.data.code != 0) {
                            return;
                        }
                        that.wards = response.data.results || [];
                    });

                    break;
                case 'avatar':
                    const reader = new FileReader();

                    const images = target.files;

                    if (images.length == 0) {
                        break;
                    }

                    const image = images[0];
                    that.avatar = image;

                    reader.onload = function (e) {
                        that.avatar_crop_data = e.target.result;
                        that.disable_button_update_avatar = false;
                    };

                    if (/\.(jpe?g|png|gif)$/i.test(image.name)) {
                        reader.readAsDataURL(image);
                    }

                    this.$nextTick(function () {
                        $('#profileUploadModal').modal('hide');
                        //$('#cropAvatarModal').modal();

                        $('#cropAvatarModal').on('shown.bs.modal', function () {
                            if (that.cropper != null) {
                                that.cropper.destroy();
                            }
                            that.cropper = new Cropper(
                                document.getElementById('image-crop'), {
                                aspectRatio: 1,
                                crop(event) {
                                    
                                }
                            });
                        });
                        $('#cropAvatarModal').modal('show');
                    });

                    break;
            }
        },

        selectAvatar(avatar) {
            this.user.avatar_id = avatar.id;
            this.user.avatar_img = avatar.url;

            this.$refs.avatar_url.setAttribute("src", avatar.url)
            //this.$refs.avatar_url.style.backgroundImage = "url('" + avatar.url + "')";

            this.disable_button_update_avatar = false;
        },

        selectEmoticon(emoticon) {
            this.user.emoji_id = emoticon.id;
            this.user.emoji_url = emoticon.url;

            this.$refs.emoticon_url.setAttribute("src", emoticon.url);

            this.disable_button_update_avatar = false;
        },

        updateAvatar() {
            const that = this;
            const formData = new FormData();

            formData.append('avatar_id', this.user.avatar_id);
            formData.append('avatar_img', this.user.avatar_img);
            formData.append('emoji_id', this.user.emoji_id ? this.user.emoji_id : 0);
            // formData.append('emoji_id', this.user.emoji_id);
            formData.append('type', this.user.type);
            formData.append('extension_file', this.user.extension_file);

            that.$store.commit("setLoading", true);
            if (this.user.avatar_id && !this.user.emoji_id) {
                this.user.type = 0;
            } else if (!this.user.avatar_id && this.user.emoji_id) {
                this.user.type = 1;
            } else {
                this.user.type = 2;
            }
            updateAvatar({
                avatar_id: this.user.avatar_id,
                avatar_img: this.user.avatar_img,
                emoji_id: this.user.emoji_id ? this.user.emoji_id : 0,
                type: this.user.type,
                extension_file: this.user.extension_file,
                //is_raw: true
            }).then((response) => {
                that.$store.commit("setLoading", false);
                that.disable_button_update_avatar = true;

                if (response.data.code != 0) {
                    alert(response.data.msg)

                    return;
                }

                const time = new Date().getTime();

                that.user_info.avatar_id = response.data.results.avatar_id;
                that.user_info.avatar_url = response.data.results.avatar_url + '?v=' + time;
                that.user_info.emoji_id = response.data.results.emoji_id;
                that.user_info.emoji_url = response.data.results.emoji_url;

                $('#uploadAvatarModal').modal('hide');
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                that.disable_button_update_avatar = true;

                console.error(response)
            });
        },

        upgradeAccount() {
            if (this.user_info.placement_test != 0) {
                const path = '/upgrade-account'
                this.$router.push(path)
            } else {
                $('#placementModal').modal('show');
            }
        },
        doTest() {
            $('#popupUpgradeAccount').modal('hide');
            $('#placementModal').modal('show');
        },

        onSubmit(e) {
            const that = this;
            if (that.is_valid == false) {
                return false;
            }
            const formData = new FormData();

            formData.append('fullname', this.user.fullname);
            formData.append('birthday', moment(this.user.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            formData.append('gender', this.user.gender);
            //formData.append('grade', this.user.grade);

            that.$store.commit("setLoading", true);

            updateProfile(formData).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    alert(response.data.msg)

                    return;
                }

                that.user_info.fullname = response.data.results.fullname;
                that.user_info.gender = response.data.results.gender;
                that.user_info.birthday = moment(response.data.results.birthday).format('DD/MM/YYYY');
                that.key_change_info = that.getKeyChangeInfo(that.user_info);
                $('#profileUpdated').modal('show');

            }).catch((response) => {
                that.$store.commit("setLoading", false);

                console.error(response)
            });

            e.preventDefault();
        },

        updateContact(e) {
            const that = this;

            if (that.is_valid == false) {
                return false;
            }
            const formData = new FormData();

            formData.append('phone', this.user.contact_user.phone);
            formData.append('email', this.user.email);
            formData.append('country_id', this.user.contact_user.country_id);
            formData.append('city_id', this.user.contact_user.city_id);
            formData.append('ward_id', this.user.contact_user.ward_id);
            formData.append('address', this.user.contact_user.address);

            that.$store.commit("setLoading", true);

            updateContact(formData).then((response) => {
                console.log(response.data);
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    that.showError_1(response.data.error_code, response.data.msg)
                    return;
                }

                that.user_info.email = response.data.results.email

                that.key_change_contact = that.getKeyChangeContact(that.user_info);

                //location.reload();

                //alert('Ok')
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                console.error(response)
            });

            e.preventDefault();
        },

        updateSchoolInfo(e) {
            const that = this;
            if (that.is_valid == false) {
                return false;
            }
            const formData = new FormData();

            formData.append('phone', this.user.contact_user.phone);
            formData.append('email', this.user.email);
            formData.append('country_id', this.user.contact_user.country_id);
            formData.append('city_id', this.user.contact_user.city_id);
            formData.append('ward_id', this.user.contact_user.ward_id);
            formData.append('address', this.user.contact_user.address);

            that.$store.commit("setLoading", true);

            updateContact(formData).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    alert(response.data.msg)

                    return;
                }

                that.user_info.fullname = response.data.results.fullname;

                //location.reload();

                //alert('Ok')
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                console.error(response)
            });

            e.preventDefault();
        },

        onLogout(e) {
            this.$store.dispatch('logout').then(() => {
                // window.location.href = "/login";
                this.$router.push("/login")
            });
            localStorage.removeItem('grade');
            e.preventDefault();
        },
        changePassword() {
            $('#ChangePasswordPopup').modal('show');
        },
        changeNewPass() {
            const that = this;
            const formData = new FormData();

            if (that.new_password.length < 8) {
                that.errors.new_password = 'the_new_password_must_be_at_least_8_characters';

                that.showError(that.errors.new_password);

                return false;
            }
            if (that.new_password == that.current_password) {
                that.showError("new_password_cannot_be_the_same_as_the_current_password");

                return false;
            }
            if (that.new_password != that.confirm_password) {
                that.showError("confirm_password_does_not_match");
                return false;
            }
            if (that.new_password == that.user.user_name) {
                that.showError("new_password_cannot_be_the_same_as_the_student_username");
                return false;
            }
            formData.append('old_pass', that.current_password)
            formData.append('new_pass', that.new_password);
            formData.append('confirm_pass', that.confirm_password);

            that.$store.commit("setLoading", true);

            changeNewPassword(formData).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    that.showError(response.data.msg);

                    return;
                }
                // alert('Ok');
                $('.modal').modal('hide');
                $('#formSuccessModal').modal('show');
                that.resetPasswordState();
            }).catch((response) => {
                that.$store.commit("setLoading", false);
            });
        },
        resetPasswordState() {
            this.current_password = '';
            this.new_password = '';
            this.confirm_password = '';
        },
        strengPassword(password) {
            let str1 = 0;
            let str2 = 0;
            let str3 = 0;
            (password.length >= 8) ? str1 = 1 : str1 = 0;
            (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) ? str2 = 1 : str2 = 0;
            // if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)){this.strength += 1}
            (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) ? str3 = 1 : str3 = 0;
            this.strength = str1 + str2 + str3;
            if (this.strength > 0) {
                this.strength_1 = 0
            }
            if (this.strength > 1) {
                this.strength_1 = 1
            }
            if (this.strength > 2) {
                this.strength_1 = 2
            }
        },
        eventValid({ target }) {
            this.is_valid = true;
            switch (target.name) {
                case 'fullname':
                    this.errors.fullname = '';
                    if (this.user.fullname.length > 50) {
                        this.errors.fullname = "Fullname max 50 characters.";
                        this.is_valid = false;
                    }
                    if (this.regexSpecialChar(this.user.fullname)) {
                        this.errors.fullname = "Fullname cannot contain special characters";
                        this.is_valid = false;
                    }
                    break;
            }
            return this.is_valid;
        },
        regexSpecialChar(txt) {
            var specialRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
            if (txt.match(specialRegex)) {
                return true;
            }
            return false;
        },
    }
}
</script>

<style scoped>
#formErrorModal_1 .modal-title {
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    color: #000000;
    padding-top: 20px;
}

#formErrorModal_1 .modal-body {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: #141821;
    padding: 30px 0px 40px;
}

#formErrorModal_1 .modal-content {
    padding: 0 85px;
}

.form-control-checked.disabled {
    filter: grayscale(1);
}

#profile-class,
#profile-grade {
    margin-bottom: 0px !important;
}

.test_button {
    /* margin-top: 30px; */
    color: #00A3FF;
    cursor: pointer;
    font-weight: bold;
}

#changePasswordModal .modal-content {
    width: 500px;
    /* height: 368px; */
    padding: 16px 50px 20px;
}

#changePasswordModal .modal-body {
    padding: 0;
}

#changePasswordModal .modal-body input {
    height: 36px;
    font-weight: 900;
    color: #000000;
}

#changePasswordModal .modal-footer {
    display: flex;
    justify-content: center;
    padding: 0;
}

#changePasswordModal .modal-header {
    padding: 0;
    margin-bottom: 15px;
}

/* .password-strength{
        display: none;
    } */
.change-password-form .form-control-password input:focus {
    border: 1px solid #F04821;
}

#formErrorModal .modal-title {
    font-size: 16px;
    color: #FF3E12;
    margin-bottom: 12px;
}

#formErrorModal .modal-header,
#formErrorModal .modal-body {
    padding: 0;
}

#formErrorModal {
    box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.15), 0px 7px 18px rgba(0, 0, 0, 0.2);
}

.btn-close {
    box-sizing: content-box;
    width: 30px;
    height: 30px;
    padding: 0.25em 0.25em;
    background: transparent url("/public/themes/ito/images/icon-closed.svg") center/18px auto no-repeat;
    border: 0;
    border-radius: 0.25rem;
    opacity: 1;
}

#profile-free-trail {
    border-radius: 50px !important;
}

.profile-free-trail-right {
    border-top-right-radius: 0;
}

.profile-free-trail-left {
    border-top-left-radius: 0;
}

#profile-free-trail .card-header {
    display: flex;
    justify-content: space-between;
    padding: 12px 20px 12px 28px;
}

#profile-free-trail .card-header .lisa-btn-fit {
    height: 32px;
    margin-left: 12px;
    /* display: flex;
        align-items: center; */
}

.lisa-btn-fit.logout {
    background: linear-gradient(0deg, #F35935, #F35935), #00A3FF;
}

#profile-free-trail .profile-basic-avatar {
    border-radius: 0 0 0 8px !important;
    background: #FFFFFF;
    margin: 0;
    width: unset;
}

#profile-free-trail .profile-basic-avatar-info {
    /* margin-left: 100px;
        margin-top: 28px;
        margin-bottom: 12px; */
    margin: 28px 100px 12px;
}

#profile-free-trail .profile-free-trail-right {
    padding: 20px 0 50px;
    padding-right: 90px;
    /* margin-left: 70px; */
}

.profile-free-trail-right #profile-fullname {
    margin-bottom: 12px;
}

.profile-free-trail-right #profile-grade {
    height: 40px;
    width: 216px;
    margin-right: 12px;
}

#profile-free-trail {
    background: #ffffff;
}

#profile-free-trail .form-label {
    margin-bottom: 2px;
}

.placement-test-link {
    text-decoration: underline;
}

.block-info {
    font-size: 14px;
    font-weight: 700;
}

.block-info .label {
    margin-right: 12px;
}

.block-info .userid {
    color: #40C0F6;
}

#profile-grade-checked .form-control-checked::after {
    right: 10px;
    left: unset;
}

.emotion.hide {
    visibility: hidden !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.ito-btn-warning {
    color: #fff;
    background: linear-gradient(0deg, #FA450F, #FA450F),
        linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
}

.ito-btn-warning:hover {
    color: #fff;

}

.custom-input.is-warning {
    padding-right: calc(1.5em + 0.75rem);
    background-image: url('data:image/svg+xml,<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7965 10.748L8.29845 1.24805C8.16655 1.02053 7.97718 0.831676 7.74932 0.70039C7.52145 0.569104 7.26309 0.5 7.00011 0.5C6.73713 0.5 6.47877 0.569104 6.2509 0.70039C6.02304 0.831676 5.83367 1.02053 5.70177 1.24805V1.24853L0.203722 10.748C0.071719 10.976 0.00208671 11.2347 0.00183176 11.4982C0.00157681 11.7616 0.0707082 12.0205 0.20227 12.2487C0.333832 12.4769 0.523184 12.6665 0.751272 12.7983C0.979361 12.9301 1.23814 12.9995 1.50157 12.9995H12.4986C12.7621 12.9995 13.0209 12.9301 13.2489 12.7983C13.477 12.6665 13.6664 12.4769 13.7979 12.2487C13.9295 12.0205 13.9986 11.7616 13.9984 11.4982C13.9981 11.2347 13.9285 10.976 13.7965 10.748ZM6.49962 5.5C6.49962 5.36739 6.5523 5.24021 6.64607 5.14645C6.73984 5.05268 6.86701 5 6.99962 5C7.13223 5 7.25941 5.05268 7.35318 5.14645C7.44694 5.24021 7.49962 5.36739 7.49962 5.5V8C7.49962 8.13261 7.44694 8.25978 7.35318 8.35355C7.25941 8.44732 7.13223 8.5 6.99962 8.5C6.86701 8.5 6.73984 8.44732 6.64607 8.35355C6.5523 8.25978 6.49962 8.13261 6.49962 8V5.5ZM6.99999 11.0002C6.85165 11.0002 6.70665 10.9562 6.58331 10.8738C6.45997 10.7914 6.36384 10.6742 6.30708 10.5372C6.25031 10.4001 6.23546 10.2493 6.2644 10.1039C6.29334 9.95838 6.36477 9.82474 6.46966 9.71985C6.57455 9.61496 6.70818 9.54353 6.85367 9.51459C6.99916 9.48565 7.14995 9.5005 7.287 9.55727C7.42404 9.61404 7.54118 9.71017 7.62359 9.8335C7.706 9.95684 7.74999 10.1018 7.74999 10.2502C7.74998 10.4491 7.67096 10.6398 7.53031 10.7805C7.38966 10.9211 7.1989 11.0002 6.99999 11.0002Z" fill="%23FA450F"/></svg>');
    background-repeat: no-repeat;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.custom-input.is-valid {
    border-color: rgba(228, 228, 228, 0.6);
    padding-right: calc(1.5em + 0.75rem);
    background-image: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.7682 6.64018C14.1218 6.21591 14.0645 5.58534 13.6402 5.23178C13.2159 4.87821 12.5853 4.93554 12.2318 5.35982L8.63383 9.67736C8.28711 10.0934 8.09219 10.3238 7.93658 10.4653L7.93063 10.4707L7.92422 10.4659C7.75643 10.339 7.54146 10.1272 7.1585 9.74428L5.70711 8.29289C5.31658 7.90237 4.68342 7.90237 4.29289 8.29289C3.90237 8.68342 3.90237 9.31658 4.29289 9.70711L5.74428 11.1585L5.78511 11.1993L5.78512 11.1993C6.11161 11.526 6.4257 11.8402 6.71794 12.0611C7.0453 12.3087 7.47402 12.5415 8.02343 12.5165C8.57284 12.4916 8.97872 12.221 9.28233 11.9448C9.55337 11.6983 9.83772 11.3569 10.1333 11.0021L10.1333 11.0021L10.1703 10.9577L13.7682 6.64018Z" fill="%2398C93C"/></svg>');
    background-repeat: no-repeat;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
</style>
